define(function(require, exports, module) {
	var browser = require('Cloud/browser');

	module.exports = function(app, _) {
		app.browser = browser;
	}
});

